import { Box, Button, Popover, PopoverContent, PopoverTrigger } from '@cad-arc';
import React, { useCallback, useEffect, useMemo } from 'react';
import { UnitFiltersForm } from '@mark43/cad-api';
import { globalAttributes } from '../../../common/global-attributes';
import { AttributeFilterSelect } from './attribute-filter-select';
import { FormProvider, useForm } from 'react-hook-form';
import { FilterSelect } from './filter-select';
import { useDispatchAreaStore } from '../../../dispatch-areas/use-dispatch-areas';
import { toOption } from '../../../dispatch-areas/to-option';
import { observer } from 'mobx-react-lite';

export const FilterPopover = observer(function FilterPopover(props: {
    setSelectedFilters: React.Dispatch<UnitFiltersForm>;
    selectedFilters: UnitFiltersForm;
    hasSelectedFilters: boolean;
}): React.ReactElement {
    const form = useForm<UnitFiltersForm>({ defaultValues: props.selectedFilters });
    const dispatchAreaStore = useDispatchAreaStore();
    const dispatchAreaOptions = useMemo(
        () => dispatchAreaStore.allDispatchAreaObjects.map(toOption),
        [dispatchAreaStore.allDispatchAreaObjects]
    );

    useEffect(() => {
        form.reset(props.selectedFilters);
    }, [form, props.selectedFilters]);

    const handleOpenChange = useCallback(
        (isOpen: boolean) => {
            if (!isOpen) {
                props.setSelectedFilters(form.getValues());
            }
        },
        [form, props]
    );

    return (
        <FormProvider {...form}>
            <Popover hasArrow={false} onOpenChange={handleOpenChange}>
                <PopoverTrigger asChild>
                    <Button
                        size="sm"
                        variant="outline"
                        trailingVisual="TriangleDown"
                        tabIndex={-1}
                        isActive={props.hasSelectedFilters}
                    >
                        Filter
                    </Button>
                </PopoverTrigger>
                <PopoverContent>
                    <Box w="340px">
                        <FilterSelect
                            options={dispatchAreaOptions}
                            label="Dispatch Area"
                            filterName="dispatchAreaIds"
                            control={form.control}
                        />
                        <AttributeFilterSelect
                            label="Police Unit Types"
                            attributeType="UNIT_TYPE"
                            filterName="policeUnitTypeIds"
                            parentAttributeId={globalAttributes.agencyTypeGlobal.POLICE}
                            control={form.control}
                        />
                        <AttributeFilterSelect
                            label="Fire Unit Types"
                            attributeType="UNIT_TYPE"
                            filterName="fireUnitTypeIds"
                            parentAttributeId={globalAttributes.agencyTypeGlobal.FIRE}
                            control={form.control}
                        />
                        <AttributeFilterSelect
                            label="EMS Unit Types"
                            attributeType="UNIT_TYPE"
                            filterName="emsUnitTypeIds"
                            parentAttributeId={globalAttributes.agencyTypeGlobal.EMS}
                            control={form.control}
                        />
                        <AttributeFilterSelect
                            label="Skills"
                            attributeType="USER_SKILL"
                            filterName="skillIds"
                            control={form.control}
                        />
                        <AttributeFilterSelect
                            label="Equipment"
                            attributeType="EQUIPMENT_TYPE"
                            filterName="equipmentIds"
                            control={form.control}
                        />
                    </Box>
                </PopoverContent>
            </Popover>
        </FormProvider>
    );
});
